import React from 'react';

const InactivityWarningModal = ({ isOpen, timeRemaining, onStayLoggedIn, onLogout }) => {
  if (!isOpen) return null;

  // Convert milliseconds to minutes and seconds
  const minutes = Math.floor(timeRemaining / 60000);
  const seconds = Math.floor((timeRemaining % 60000) / 1000);

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity" />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn">
          {/* Icon */}
          <div className="flex items-center justify-center w-12 h-12 mx-auto bg-yellow-100 rounded-full">
            <svg
              className="w-6 h-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          {/* Title */}
          <h3 className="mt-4 text-lg font-semibold text-gray-900 text-center">
            Session Timeout Warning
          </h3>

          {/* Message */}
          <p className="mt-2 text-sm text-gray-600 text-center">
            You've been inactive for a while. For your security, you'll be automatically logged out in:
          </p>

          {/* Countdown Timer */}
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <div className="text-3xl font-bold text-indigo-600 text-center font-mono">
              {minutes}:{seconds.toString().padStart(2, '0')}
            </div>
            <div className="text-xs text-gray-500 text-center mt-1">
              minutes remaining
            </div>
          </div>

          {/* Info */}
          <p className="mt-4 text-xs text-gray-500 text-center">
            Click "Stay Logged In" to continue your session, or "Logout" to end it now.
          </p>

          {/* Buttons */}
          <div className="mt-6 flex gap-3">
            <button
              onClick={onLogout}
              className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
            >
              Logout
            </button>
            <button
              onClick={onStayLoggedIn}
              className="flex-1 px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
            >
              Stay Logged In
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InactivityWarningModal;
